module.exports = __webpack_public_path__ + "img/art5.9fd1b842.png";